import { bbkApiSlice } from '@bbkAdminRedux/rtkq/bbkApi.slice';
import { brightbackAuthSlice } from '@bbkAdminRedux/rtkq/brightback-auth.slice';
import { internalBbkApiSlice } from '@bbkAdminRedux/rtkq/internal.bbkApi.slice';
import { preauthBbkApiSlice } from '@bbkAdminRedux/rtkq/preauth.bbkApi.slice';
import { unauthorizedRedirectMiddleware } from '@bbkAdminRedux/rtkq/unauthorized-redirect.middleware';

export const reducersMiddlewares = [
  preauthBbkApiSlice.middleware,
  bbkApiSlice.middleware,
  internalBbkApiSlice.middleware,
  brightbackAuthSlice.middleware,
  unauthorizedRedirectMiddleware,
];
